import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import {
  formatInternational,
  getCountryCodeFromPhoneNumber,
  getPhoneNumberCountryCodeFormatted,
} from 'lib-shared-phone-numbers';
import _filter from 'lodash/filter';
import { PureComponent } from 'react';
import Collapsible from 'react-collapsible';

import ListNumbers from './ListNumbers';
import PhoneNumbersCustomInput from './PhoneNumbersCustomInput';

import '../styles/from-number-selector.less';

type PropsT = {
  meta: any;
  nextPage: string | null;
  previousPage: string | null;
  fromNumberFormat: string | null;
  selectedFromNumber: any;
  isOwnNumbersViewOpen: boolean;
  dynamicTelephoneNumbersArray: Array<any>;
  staticTelephoneNumbersArray: Array<any>;
  agentDefaultNumber: string | null;

  changeFromNumber: (payload: any) => void;
  toggleOwnNumbersView: (isOpen: boolean) => void;
  setFromNumberCountryCode: (countryCode: any) => void;
  telephonyGetQueryNumbers: (payload: any) => Promise<any>;
  telephonyGetAllOwnNumbers: () => Promise<any>;
  telephonyGetDefaultNumber: () => Promise<any>;
  returnFromNumberFormat: (fromNumberFormat: string | null) => void;
};

type StateT = {
  fromNumberRegion: string;
  fromNumberCountryCode?: any;
};

export default class CustomDropDownButton extends PureComponent<
  PropsT,
  StateT
> {
  constructor(props: PropsT) {
    super(props);
    this.state = {
      fromNumberRegion: 'Unknown',
    };
  }

  UNSAFE_componentWillMount() {
    this.props.telephonyGetAllOwnNumbers();
    this.props.telephonyGetDefaultNumber();
  }

  componentDidUpdate(prevProps: PropsT) {
    let verifiedNumbers: any[] | null = null;

    if (this.props.agentDefaultNumber) {
      verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
        e164_format: this.props.agentDefaultNumber,
      });
    } else {
      verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
        default: true,
      });
    }

    if (!verifiedNumbers || verifiedNumbers.length === 0) {
      verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
        outgoing_functionality: true,
      });
    }

    if (this.props.selectedFromNumber === null && verifiedNumbers.length > 0) {
      let outboundNumber = '';
      if (this.props.fromNumberFormat) {
        outboundNumber = this.props.fromNumberFormat;
      } else {
        outboundNumber = '+4560860931';
      }
      const fromNumber = this.findNumberByCountryCode(outboundNumber); // @TODO make a default counrty for each organization.

      if (fromNumber !== null) {
        this.changeFromNumber(fromNumber);
      } else {
        this.changeFromNumber(verifiedNumbers[0]);
      }
    }

    if (prevProps.selectedFromNumber !== this.props.selectedFromNumber) {
      this.changeFromNumber(this.props.selectedFromNumber);
    }
  }

  fromNumberFormat = (fromNumberFormat: string | null) => {
    this.props.returnFromNumberFormat(fromNumberFormat);
  };

  findNumberByCountryCode = (number: string | null = null): string | null => {
    let verifiedNumbers: any[] | null = null;

    if (this.props.staticTelephoneNumbersArray.length === 0) {
      console.warn(
        '_findSameOwnNumberWithSameCountryCode no owned number given.',
      );
      return null;
    }

    if (this.props.agentDefaultNumber) {
      verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
        e164_format: this.props.agentDefaultNumber,
      });
    } else {
      verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
        default: true,
      });
    }

    if (!verifiedNumbers || verifiedNumbers.length === 0) {
      verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray);
    }

    let foundNumber: null | string = null;
    if (number !== null) {
      // find country code on number and match it with a from number (if any).
      const countryCode = getPhoneNumberCountryCodeFormatted(number);
      for (const ownedNumber of verifiedNumbers) {
        const ownedCountryCode = getPhoneNumberCountryCodeFormatted(
          ownedNumber.e164_format,
        );

        if (countryCode === ownedCountryCode) {
          // Found own number with same countryCode as user.
          foundNumber = ownedNumber;
          break;
        }
      } // end loop.
    }
    return foundNumber;
  };

  onOwnNumberToggle = () => {
    if (this.props.isOwnNumbersViewOpen) {
      this.props.toggleOwnNumbersView(false);
    } else {
      this.props.toggleOwnNumbersView(true);
    }
  };

  changeFromNumber = (fromNumber: any = null) => {
    if (fromNumber === null) {
      return;
    }
    this.props.changeFromNumber({ number: fromNumber });
    const fromPhoneNumberFormat =
      formatInternational(fromNumber.e164_format) || fromNumber.e164_format;
    const fromNumberRegion =
      getCountryCodeFromPhoneNumber(fromNumber.e164_format)?.toUpperCase() ||
      'Unknown';
    const fromNumberCountryCode =
      getPhoneNumberCountryCodeFormatted(fromNumber.e164_format) || null;
    this.props.setFromNumberCountryCode(fromNumberCountryCode);
    this.props.returnFromNumberFormat(fromPhoneNumberFormat);
    this.setState({ fromNumberRegion, fromNumberCountryCode });
  };

  render() {
    let fromNumber: JSX.Element | null = null;
    let disabledPrevious = '';
    let disabledNext = '';
    let previousLink;
    let nextLink;
    let isHidden = '';
    let buttonsHidden = '';

    if (
      this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
      this.props.staticTelephoneNumbersArray.length > 0 &&
      this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
      this.props.dynamicTelephoneNumbersArray.length === 0
    ) {
      buttonsHidden = ' hidden';
    }

    if (this.props.selectedFromNumber && this.props.selectedFromNumber.name) {
      fromNumber = (
        <div className="call-from flags">
          <p className="m-b-5 noselect">Outbound number</p>
          <Tooltip content="Outbound call recording is active">
            <span
              className={
                'call-recording ' +
                (this.props.selectedFromNumber.record_outbound_calls === true
                  ? ''
                  : 'hidden')
              }
            >
              <Icon name="rec" />
            </span>
          </Tooltip>
          <span
            className={'flag ' + this.state.fromNumberRegion.toLowerCase()}
          ></span>
          <Tooltip side="bottom" content={this.props.selectedFromNumber.name}>
            <span className="from-number-name">
              {this.props.fromNumberFormat}{' '}
              <em>({this.props.selectedFromNumber.name})</em>
            </span>
          </Tooltip>
          <Icon
            name="angle-right"
            size={20}
            className="Collapsible__trigger-icon"
          />
        </div>
      );
    } else if (this.props.selectedFromNumber) {
      fromNumber = (
        <div className="call-from flags">
          <p className="m-b-5 noselect">Outbound number</p>
          <Tooltip content="Outbound call recording is active">
            <span
              className={
                'call-recording ' +
                (this.props.selectedFromNumber.record_outbound_calls === true
                  ? ''
                  : 'hidden')
              }
            ></span>
          </Tooltip>
          <span
            className={'flag ' + this.state.fromNumberRegion.toLowerCase()}
          ></span>
          <span>{this.props.fromNumberFormat}</span>
          <Icon
            name="angle-right"
            size={20}
            className="Collapsible__trigger-icon"
          />
        </div>
      );
    }

    if (this.props.previousPage === null) {
      disabledPrevious = 'disabled';
      previousLink = (
        <a type="button">
          <span style={{ verticalAlign: '-2px' }}>
            <Icon name="arrow-left" />
          </span>
          Prev Page
        </a>
      );
    } else {
      previousLink = (
        <a
          type="button"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            this.props.telephonyGetQueryNumbers({
              query: { path: this.props.previousPage, limit: '15' },
            })
          }
        >
          <span style={{ verticalAlign: '-2px' }}>
            <Icon name="arrow-left" />
          </span>
          Prev Page
        </a>
      );
    }

    if (this.props.nextPage === null) {
      disabledNext = 'disabled';
      nextLink = (
        <a className={buttonsHidden} type="button">
          Next page
          <span style={{ verticalAlign: '-2px' }}>
            <Icon name="arrow-right" />
          </span>
        </a>
      );
    } else {
      nextLink = (
        <a
          className={buttonsHidden}
          type="button"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            this.props.telephonyGetQueryNumbers({
              query: { path: this.props.nextPage, limit: '15' },
            })
          }
        >
          Next page
          <span style={{ verticalAlign: '-2px' }}>
            <Icon name="arrow-right" />
          </span>
        </a>
      );
    }

    if (
      this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
      this.props.staticTelephoneNumbersArray.length === 0
    ) {
      isHidden = ' hidden';
    }

    return (
      <div className={`collapsible-holder from-numbers-selector${isHidden}`}>
        <Collapsible
          handleTriggerClick={this.onOwnNumberToggle}
          open={this.props.isOwnNumbersViewOpen}
          trigger={fromNumber as any}
          transitionTime={300}
          easing="ease"
        >
          <li className="own-number-change dropdown-header" role="heading">
            Search outbound numbers
          </li>
          <PhoneNumbersCustomInput
            telephonyGetQueryNumbers={this.props.telephonyGetQueryNumbers}
          />
          <li
            className={`own-number-change${buttonsHidden} dropdown-header`}
            role="presentation"
          >
            Select outbound number
          </li>
          <ListNumbers
            dynamicTelephoneNumbersArray={
              this.props.dynamicTelephoneNumbersArray
            }
            onToggle={this.onOwnNumberToggle}
            selectedFromNumber={this.props.selectedFromNumber}
            changeFromNumber={this.changeFromNumber}
          />
          {(this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus ===
            'loading' && (
            <ul className={`pager${buttonsHidden}`} style={{ margin: 'auto' }}>
              <li className="disabled pull-left">
                {
                  <a type="button">
                    {' '}
                    <span style={{ verticalAlign: '-2px' }}>
                      <Icon name="arrow-left" />
                    </span>
                    Loading{' '}
                  </a>
                }
              </li>
              <li className="disabled pull-right">
                {
                  <a type="button">
                    {' '}
                    Loading{' '}
                    <span style={{ verticalAlign: '-2px' }}>
                      {' '}
                      <Icon name="arrow-right" />{' '}
                    </span>
                  </a>
                }
              </li>
            </ul>
          )) || (
            <ul className={`pager${buttonsHidden}`} style={{ margin: 'auto' }}>
              <li className={disabledPrevious + ' previous'}>{previousLink}</li>
              <li className={disabledNext + ' next'}>{nextLink}</li>
            </ul>
          )}
        </Collapsible>
        <li
          className="divider"
          role="separator"
          style={{ margin: '13px 0 0 0', width: '100%', listStyleType: 'none' }}
        />
      </div>
    );
  }
}
